import { createReducer } from 'redux-act';

import {
  addSavedRestaurantVoucher,
  setCanApplyRestaurantVoucher,
  setPayment,
  setRestaurantVouchers,
  setState,
  setStatus,
  updatePayment,
} from './actions';

export const defaultPaymentState: WebOrder.State.Payments = {
  canApplyRestaurantVoucher: false,
  items: {},
  restaurantVouchers: {},
  status: 'none',
};

const paymentsReducer = createReducer({}, defaultPaymentState);

paymentsReducer.on(setState, (state, payload) => ({
  ...payload,
}));

paymentsReducer.on(setStatus, (state, payload) => ({
  ...state,
  ...payload,
}));

paymentsReducer.on(setPayment, (state, payload) => ({
  ...state,
  items: {
    ...state.items,
    [payload.paymentId]: {
      ...payload,
    },
  },
}));

paymentsReducer.on(updatePayment, (state, payload) => ({
  ...state,
  items: {
    ...state.items,
    [payload.paymentId]: {
      ...state.items[payload.paymentId],
      ...payload,
    },
  },
}));

paymentsReducer.on(setCanApplyRestaurantVoucher, (state, payload) => {
  let canApplyRestaurantVoucher = false;
  if (payload?.status === 'success') {
    const itemsExcludedFromVoucher =
      payload?.data?.CategorizedMenuItems?.CanNotApplyRestaurantVoucher || [];
    canApplyRestaurantVoucher = itemsExcludedFromVoucher.length === 0;
  }
  return {
    ...state,
    canApplyRestaurantVoucher,
  };
});

paymentsReducer.on(setRestaurantVouchers, (state, payload) => {
  const isSuccess = payload.status === 'success';

  const acceptedVouchers = isSuccess
    ? payload.data.AcceptedRestaurantVouchers
    : [];
  const savedVouchers = isSuccess
    ? payload.data.SavedUserRestaurantVouchers
    : [];

  return {
    ...state,
    restaurantVouchers: {
      ...state.restaurantVouchers,
      [payload.storeId]: {
        status: payload.status,
        acceptedVouchers,
        savedVouchers,
      },
    },
  };
});

paymentsReducer.on(addSavedRestaurantVoucher, (state, payload) => {
  const savedVouchers =
    state?.restaurantVouchers[payload.storeId]?.savedVouchers || [];

  const isUniqueVoucherAdded =
    payload.status === 'success' &&
    payload.data.Status === 'Active' &&
    !savedVouchers.some(
      (voucher) => voucher.PaymentAccountId === payload.data.PaymentAccountId,
    );

  if (isUniqueVoucherAdded) {
    savedVouchers.push(payload.data);
  }

  return {
    ...state,
    restaurantVouchers: {
      ...state.restaurantVouchers,
      [payload.storeId]: {
        ...state.restaurantVouchers[payload.storeId],
        status: payload.status,
        savedVouchers,
      },
    },
  };
});

export { paymentsReducer };
